import { useEffect, useRef, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { api, BACKEND } from "../lib/api";

const INTERVAL = 10000;
const src = (url) => (url.startsWith("/api/") ? `${BACKEND}${url}` : url);

function Slide({ b, index }) {
  const body = (
    <div className="h-full w-full" style={{ background: b.bg || undefined }}>
      <img src={src(b.image_url)} alt="" draggable={false} loading={index === 0 ? "eager" : "lazy"}
        className={`h-full w-full ${b.fit === "contain" ? "object-contain" : "object-cover"}`} />
    </div>
  );
  const external = b.link && /^https?:\/\//.test(b.link);
  const tap = () => api.post(`/banners/${b.id}/tap`).catch(() => {});
  return (
    <div className="relative h-full min-w-0 flex-[0_0_100%]" data-testid={`home-banner-slide-${index}`}>
      {b.link ? <a href={b.link} onClick={tap} {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})} className="block h-full" data-testid={`home-banner-link-${index}`}>{body}</a> : body}
    </div>
  );
}

export function useBanners(region) {
  const [banners, setBanners] = useState(null);
  useEffect(() => {
    api.get("/banners", { params: { region } }).then((r) => setBanners(r.data)).catch(() => setBanners([]));
  }, [region]);
  return banners;
}

export function BannerCarousel({ banners }) {
  const multi = banners.length > 1;
  const [emblaRef, embla] = useEmblaCarousel({ loop: multi, watchDrag: multi });
  const [selected, setSelected] = useState(0);
  const touching = useRef(false);

  useEffect(() => {
    if (!embla) return undefined;
    const onSelect = () => setSelected(embla.selectedScrollSnap());
    const hold = () => (touching.current = true);
    const release = () => (touching.current = false);
    embla.on("select", onSelect).on("pointerDown", hold).on("pointerUp", release);
    const id = multi ? setInterval(() => !touching.current && embla.scrollNext(), INTERVAL) : null;
    return () => {
      clearInterval(id);
      embla.off("select", onSelect).off("pointerDown", hold).off("pointerUp", release);
    };
  }, [embla, multi]);

  useEffect(() => {
    const b = banners[selected];
    if (!b) return;
    const key = `mm_banner_view_${b.id}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    api.post(`/banners/${b.id}/view`).catch(() => {});
  }, [selected, banners]);

  return (
    <div className="relative h-full w-full overflow-hidden bg-mist" data-no-swipe data-testid="home-banner">
      <div ref={emblaRef} className="h-full overflow-hidden touch-pan-y">
        <div className="flex h-full">
          {banners.map((b, i) => <Slide key={b.id} b={b} index={i} />)}
        </div>
      </div>
    </div>
  );
}
